// The signed-in user's blocked user ids, readable without React (the api client uses it to
// drop blocked people's items from list responses). Written by hooks/useBlockedUsers.
let ids = new Set();

export function setBlockedIds(list) {
  ids = new Set((list || []).map((id) => Number(id)));
}

export function isBlockedId(id) {
  return id != null && ids.has(Number(id));
}

export function hasBlocked() {
  return ids.size > 0;
}
